import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

import { FormField } from 'components/form/formField/formField';
import { Input } from 'components/inputs';

import { LABELS } from '../../../keys';
import { Label, Section } from '../../form.styles';
import { ACHFormField, ACHFormValues, FORM_FIELDS } from '../ach.keys';

interface IndividualAccountOwnerFormProps {
  form: FormikProps<ACHFormValues>;
  onFormChange: (field: ACHFormField) => (value: string) => void;
  getFieldError: (field: ACHFormField) => string | undefined;
}

const IndividualAccountOwnerForm = ({ form, onFormChange, getFieldError }: IndividualAccountOwnerFormProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Section>
        <Label>{t(LABELS.CREATE_MODAL.SECTIONS.FIRST_NAME_SECTION.TITLE)}</Label>
        <FormField error={getFieldError(FORM_FIELDS.FIRST_NAME)}>
          <Input
            placeholder={t(LABELS.CREATE_MODAL.FORM_FIELDS.PLACEHOLDERS.FIRST_NAME)}
            value={form.values[FORM_FIELDS.FIRST_NAME]}
            onChange={onFormChange(FORM_FIELDS.FIRST_NAME)}
          />
        </FormField>
      </Section>

      <Section>
        <Label>{t(LABELS.CREATE_MODAL.SECTIONS.LAST_NAME_SECTION.TITLE)}</Label>
        <FormField error={getFieldError(FORM_FIELDS.LAST_NAME)}>
          <Input
            placeholder={t(LABELS.CREATE_MODAL.FORM_FIELDS.PLACEHOLDERS.LAST_NAME)}
            value={form.values[FORM_FIELDS.LAST_NAME]}
            onChange={onFormChange(FORM_FIELDS.LAST_NAME)}
          />
        </FormField>
      </Section>
    </>
  );
};

export default IndividualAccountOwnerForm;
